import React from 'react';
import { Box, BoxProps } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const FormFieldsWrapper = ({ children, ...boxProps }: { children: React.ReactNode } & BoxProps) => (
  <Box
    display="flex"
    alignItems="center"
    bg="white"
    minHeight={pxToRem(50)}
    borderRadius={pxToRem(32)}
    position="relative"
    border="solid 1px"
    borderColor="mono3"
    paddingX={5}
    paddingY={3}
    {...boxProps}
  >
    {children}
  </Box>
);
